import React, { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import { SearchOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import LandingLayout from "../../../layout/LandingLayout";
import { colors, theme } from "../../../theme/theme";
import { CustomInput } from "../../../components/Common/CustomInput";
import { getAllPosts } from "../../../redux/dispatchers/posts.dispatcher";

const LandingPosts = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { allPosts } = useSelector((state) => state.posts);
  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(getAllPosts());
  }, [dispatch]);

  const filteredPosts = (allPosts || []).filter((post) =>
    post.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <LandingLayout>
      <Typography
        sx={{
          color: "#fff",
          fontFamily: "Mulish-Bold",
          fontSize: "24px",
          mb: 3,
        }}
      >
        Recent posts
      </Typography>
      <Grid container spacing={3}>
        <Grid item size={{ xs: 12, md: 8 }}>
          <Stack spacing={3}>
            {filteredPosts.map((post) => (
              <Box
                key={post.id}
                onClick={() =>
                  navigate("/posts/post-details", { state: { postId: post.id } })
                }
                sx={{
                  borderRadius: "18px",
                  overflow: "hidden",
                  border: theme.lightBorder,
                  cursor: "pointer",
                }}
              >
                <Box
                  component="img"
                  src={post.images?.[0]?.image_url}
                  alt={post.title}
                  sx={{
                    width: "100%",
                    height: { xs: "200px", md: "320px" },
                    objectFit: "cover",
                    display: "block",
                  }}
                />
                <Box sx={{ p: { xs: 2, md: 3 } }}>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontFamily: "Mulish-Bold",
                      fontSize: "18px",
                      mb: 0.5,
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.75)",
                      fontFamily: "Mulish-Regular",
                      fontSize: "14px",
                      mb: 1,
                    }}
                  >
                    {post.content}
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.5)",
                      fontFamily: "Mulish-Regular",
                      fontSize: "12px",
                    }}
                  >
                    {post.date}
                  </Typography>
                </Box>
              </Box>
            ))}
            {filteredPosts.length === 0 && (
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.6)",
                  fontFamily: "Mulish-Regular",
                  fontSize: "14px",
                }}
              >
                No posts found.
              </Typography>
            )}
          </Stack>
        </Grid>

        <Grid item size={{ xs: 12, md: 4 }}>
          <CustomInput
            placeholder="Search posts"
            value={search}
            handleChange={(e) => setSearch(e.target.value)}
            Icon={SearchOutlined}
            width="100%"
            color="#fff"
            borderColor={colors.secondary}
          />

          <Typography
            sx={{
              color: "#fff",
              fontFamily: "Mulish-Bold",
              fontSize: "16px",
              mt: 3,
              mb: 1.5,
            }}
          >
            Popular posts
          </Typography>
          <Stack spacing={1.5}>
            {(allPosts || []).slice(0, 3).map((post) => (
              <Stack
                key={post.id}
                direction="row"
                spacing={1.5}
                alignItems="center"
                onClick={() =>
                  navigate("/posts/post-details", { state: { postId: post.id } })
                }
                sx={{ cursor: "pointer" }}
              >
                <Box
                  component="img"
                  src={post.images?.[0]?.image_url}
                  alt={post.title}
                  sx={{
                    width: "56px",
                    height: "56px",
                    borderRadius: "8px",
                    objectFit: "cover",
                  }}
                />
                <Box>
                  <Typography
                    sx={{
                      color: "#fff",
                      fontFamily: "Mulish-SemiBold",
                      fontSize: "13px",
                    }}
                  >
                    {post.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "rgba(255,255,255,0.5)",
                      fontFamily: "Mulish-Regular",
                      fontSize: "11px",
                    }}
                  >
                    {post.date}
                  </Typography>
                </Box>
              </Stack>
            ))}
          </Stack>
        </Grid>
      </Grid>
    </LandingLayout>
  );
};

export default LandingPosts;
